<template>
<div>
  <div class="background-w" @click="$emit('close-menu')">
  </div>

  <div class="slide-up-menu">
    <div class="target-title">
      <div class="title" style="margin-bottom: 0">
        <!-- <i v-show="target.type === 'ITEM'" class="material-icons">assignment</i>
        <i v-show="target.type === 'FOLDER'" class="material-icons">folder</i> -->
        <span>{{target.index}} {{target.name}}</span>
      </div>
      <div class="close-button">
        <i class="material-icons" @click="$emit('close-menu')">close</i>
      </div>
    </div>
    <div class="sep-line"></div>
    <div class="menu-button-w">
      <slot></slot>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'SlideUpMenu',
  props: ['target'],
  methods: {
    renameFolder: function () {
      // console.log('RENAME FOLDER')
    }
  }
}
</script>

<style scoped>
.background-w {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2200
}
.close-button {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  padding: 12px;
  cursor: pointer;
}
.slide-up-menu {
  width: 100%;
  max-width: 500px;
  margin: auto;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right:0;
  z-index: 2201;
  box-sizing: border-box;
  padding: 20px 0;
  border-radius: 20px 20px 0 0;
  animation: slideUp 0.3s ease;
}
.target-title {
  box-sizing: border-box;
  font-weight: bold;
  line-height: 27px;
  padding: 4px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  text-transform: capitalize;
}
.sep-line {
  height: 1px;
  background-color: #f0f0f0;
  width: calc(100% - 40px);
  margin: 0 auto 8px auto;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
